import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Business, Phone, LocationOn } from '@mui/icons-material';

interface CompanyInfoBlockProps {
  name?: string;
  phone?: string;
  address?: string;
}

export const CompanyInfoBlock = ({ name, phone, address }: CompanyInfoBlockProps) => {
  return (
    <Box sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 2, bgcolor: 'grey.50', p: '12px 16px' }}>
      <Stack direction="row" gap={1.5} alignItems="center" mb={1.5}>
        <Business sx={{ fontSize: 22, color: 'grey.600' }} />

        <Typography variant="subtitle2" component="span">
          Company Information
        </Typography>
      </Stack>

      <Stack gap={0.5}>
        <Typography variant="body1">{name}</Typography>

        <Stack direction="row" gap={2}>
          {phone && (
            <Stack direction="row" gap={0.5} alignItems="center">
              <Phone sx={{ fontSize: 20, color: 'grey.600' }} />
              <Typography variant="body2" color="text.secondary">
                {phone}
              </Typography>
            </Stack>
          )}

          {address && (
            <Stack direction="row" gap={0.5} alignItems="center">
              <LocationOn sx={{ fontSize: 20, color: 'grey.600' }} />
              <Typography variant="body2" color="text.secondary">
                {address}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
